<template>
  <b-row>
    <b-col v-for="tile in tiles" :key="tile.title" cols="6" md="3" class="mb-1">
      <b-card no-body class="border h-100 mb-0">
        <b-card-body class="py-1 px-1">
          <div class="d-flex align-items-center">
            <b-avatar rounded size="38" :variant="`light-${tile.variant}`" class="mr-1">
              <feather-icon size="18" :icon="tile.icon" />
            </b-avatar>
            <div class="truncate">
              <h4 class="mb-0 font-weight-bolder">{{ tile.value }}</h4>
              <small class="text-muted">{{ tile.title }}</small>
            </div>
          </div>
          <div v-if="tile.caption" class="text-muted small mt-50">{{ tile.caption }}</div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BAvatar } from 'bootstrap-vue'
import {
  errorRateVariant,
  formatBytes,
  formatCount,
  formatDuration,
  formatPercent,
} from './usageFormat'

export default {
  name: 'UsageTotals',
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BAvatar,
  },
  props: {
    totals: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tiles() {
      const totals = this.totals || {}

      const rejected =
        (totals.unauthenticated || 0) + (totals.forbidden || 0) + (totals.rate_limited || 0)

      return [
        {
          title: 'Requests',
          value: formatCount(totals.requests),
          icon: 'ActivityIcon',
          variant: 'primary',
          caption: `${formatCount(totals.success)} succeeded`,
        },
        {
          title: 'Error rate',
          value: formatPercent(totals.error_rate),
          icon: 'AlertTriangleIcon',
          variant: errorRateVariant(totals.error_rate),
          caption: rejected ? `${formatCount(rejected)} refused or throttled` : 'none refused',
        },
        {
          title: 'p95 latency',
          value: formatDuration(totals.p95_ms),
          icon: 'ClockIcon',
          variant: 'info',
          caption: `median ${formatDuration(totals.p50_ms)} · approx.`,
        },
        {
          title: 'Data served',
          value: formatBytes(totals.response_bytes),
          icon: 'DatabaseIcon',
          variant: 'success',
          caption: `${formatCount(totals.rows_served)} records`,
        },
      ]
    },
  },
}
</script>
